var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTiktok(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5 35C27.165 35 35 27.165 35 17.5C35 7.83502 27.165 0 17.5 0C7.83502 0 0 7.83502 0 17.5C0 27.165 7.83502 35 17.5 35ZM16.271 18.219V15.4211C15.558 15.3136 14.8303 15.3585 14.1359 15.5529C13.4415 15.7473 12.7962 16.0868 12.2426 16.5489C11.689 17.011 11.2397 17.5853 10.9244 18.2338C10.609 18.8823 10.4348 19.5903 10.4131 20.311C10.4131 22.7417 12.1652 25.6459 15.591 25.6459C19.2818 25.6459 20.769 22.8458 20.7683 20.3372V14.7938C22.2586 15.9183 24.5862 16.0834 24.5862 16.0834V13.2766C22.6255 12.9628 21.161 12.2831 20.6903 9.35419H17.9218V20.4442C17.9218 21.5882 17.307 22.8125 15.568 22.8125C13.9838 22.8125 13.2146 21.7266 13.2146 20.475C13.2293 20.1107 13.3257 19.7544 13.4966 19.4323C13.6674 19.1102 13.9084 18.8305 14.2018 18.614C14.4951 18.3975 14.8334 18.2496 15.1915 18.1812C15.5496 18.1128 15.9186 18.1257 16.271 18.219Z",
    fill: "#414142"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktok);
export default __webpack_public_path__ + "static/media/tiktok.3d8e637373ecc6b26cbdb2ac5afd2509.svg";
export { ForwardRef as ReactComponent };